import { useTranslation } from "react-i18next";

import { PLAN_NAMES } from "./content";
import { formatPrice, formatPromoUntil, priceAfterPromo, tierPrice } from "./pricing";
import styles from "./Planes.module.scss";

// Cómo se muestra un plan (nombre, color, leyenda de la promo). Lo usan la pantalla de Planes,
// sus modales y el formulario de suscripción, así que vive fuera de PlanCard.

export const planName = (t, plan) => {
  const name = PLAN_NAMES[plan.code];
  return name ? t(name[0], name[1]) : plan.name;
};

export const planTheme = (code) => styles[`plan_${code}`] || styles.plan_basic;

// Promo de Premium para clientes actuales (api#588, definición de Maia 02/11): paga con los
// tramos de Pro hasta la factura de `promo.until`; desde la siguiente, el precio de lista.
export function PromoNote({ plan, activeAgendas, className }) {
  const { t } = useTranslation();
  const until = formatPromoUntil(plan.promo?.until);
  if (!until) return null;
  const after = priceAfterPromo(plan, activeAgendas);
  return (
    <p className={className} data-testid="premium-promo">
      {after != null
        ? t("planes_premium_promo_price", "Precio de Pro hasta la factura del {{date}}. Desde la siguiente, {{price}} por agenda + IVA.", {
            date: until,
            price: formatPrice(after),
          })
        : t("planes_premium_promo", "Precio de Pro hasta la factura del {{date}}. Desde la siguiente, precio de lista de Premium.", {
            date: until,
          })}
    </p>
  );
}

// Fila "Precio" de los modales de cambio de plan (upgrade y plan elegido): precio por agenda del
// tramo de las agendas activas y, si se conocen, el total. Va dentro del <dl> del resumen.
export function PriceRow({ plan, activeAgendas }) {
  const { t } = useTranslation();
  const agendas = Number.isInteger(activeAgendas) && activeAgendas > 0 ? activeAgendas : null;
  const price = plan ? tierPrice(plan, agendas ?? 1) : null;
  if (price == null) return null;
  return (
    <div data-testid="change-plan-price">
      <dt>{t("planes_change_price", "Precio")}</dt>
      <dd>
        {/* "por agenda", como las cards (antes decía "por profesional"). */}
        {t("planes_change_price_value_agenda", "{{price}} por agenda por mes + IVA", { price: formatPrice(price) })}
        {agendas && (
          <>
            <br />
            {t("planes_change_price_total", "{{total}}/mes + IVA con tus {{count}} agendas activas", {
              total: formatPrice(price * agendas),
              count: agendas,
            })}
          </>
        )}
      </dd>
    </div>
  );
}

// Aclaración debajo del precio: la promo de Premium si aplica, si no "precio de lista".
export function PriceHint({ plan, activeAgendas, className }) {
  const { t } = useTranslation();
  if (!plan) return null;
  return plan.promo ? (
    <PromoNote plan={plan} activeAgendas={activeAgendas} className={className} />
  ) : (
    <p className={className}>{t("planes_change_price_hint", "Precio de lista, sin descuentos.")}</p>
  );
}
